import { Component } from 'react';
import { connect } from 'react-redux'
import React from 'react';
import { verifyUser, userReset } from '../../../redux/actions/userAction';
import { withRouter } from 'react-router';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

// -- Application assets
import logo from '../../../assets/img/application_logo.png';



class Authenticate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            countDown: 60
        }

        this.handleSubmit = this.handleSubmit.bind(this);

        this.countDown = this.countDown.bind(this);
    }

    handleSubmit(e) {
        if(e){
            e.preventDefault();
        }

        this.props.verifyUser(this.props.clientPath + '/api/user/action/verify', {verify_code: this.state.verify_code}, {user_email: this.props.user.user_email, user_password: this.props.user.user_password});

    }

    componentDidMount() {
        this.countDown();

        document.getElementById('name').focus();

        document.querySelector('title').innerHTML = 'MijnDP - Verificatie';
    }

    countDown() {

        if(this.state.countDown === 0) {
            this.props.userReset();
            this.props.history.push('/login');
        }else{
            this.setState({countDown: this.state.countDown -1});
            setTimeout(this.countDown, 1000);
        }

    }

    updateVerifyCode(e) {
        this.setState({
            verify_code: e.target.value
        });
    }

    render() {

        return (

             <div>

                    <div className="login-wrapper">
                    <div className="card">
                        <div className="card__body">
                        <div className="login-fields">
                            <img alt={"DP Logo"} src={logo} />
                            <form onSubmit={(e) => this.handleSubmit(e)}>
                                <p>Voor extra veiligheid hebben we u een SMS-bericht met een 6-cijferige code gestuurd.</p>
                                <TextField
                                    id="name"
                                    floatingLabelText="Bevestigingscode"
                                    fullWidth={true}
                                    onChange={(e) => this.updateVerifyCode(e)}
                                />

                                <div className="pt20">
                                    <RaisedButton label={"Code verloopt over " + this.state.countDown} primary={false} fullWidth={true}/>
                                </div>
                                <div className="pt20">
                                    <RaisedButton onClick={() => this.handleSubmit()} label="Log In" primary={true} fullWidth={true}/>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {

    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        verifyUser: (url, postData, userData) => dispatch(verifyUser(url, postData, userData)),
        userReset: () => dispatch(userReset())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authenticate))



// WEBPACK FOOTER //
// ./src/components/Login/Authenticate/index.js